import { useRouteLoaderData } from 'react-router-dom'
import type { Me } from '@/lib/api'

/** The signed-in user from the 'app' route loader. Null only outside the gate. */
export function useMe(): Me | null {
  return (useRouteLoaderData('app') as Me | null) ?? null
}
